import { render, staticRenderFns } from "./IconStatusOpen.vue?vue&type=template&id=f5895870&"
import script from "./IconStatusOpen.vue?vue&type=script&lang=ts&"
export * from "./IconStatusOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports